var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "delete-alert", role: "dialog" },
      on: {
        click: function($event) {
          _vm.$emit("close")
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header bg-color-info" }, [
              _c(
                "button",
                {
                  staticClass: "close close-btn",
                  attrs: { type: "button", "data-dismiss": "modal" },
                  on: {
                    click: function($event) {
                      _vm.$emit("close")
                    }
                  }
                },
                [_vm._v(" ×")]
              )
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  ref: "deletebutton",
                  staticClass: "btn btn-warning",
                  attrs: { type: "button", "data-dismiss": "modal" },
                  on: {
                    click: function($event) {
                      _vm.$emit("confirm")
                    }
                  }
                },
                [_vm._v("OK")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn",
                  attrs: { type: "button", "data-dismiss": "modal" },
                  on: {
                    click: function($event) {
                      _vm.$emit("close")
                    }
                  }
                },
                [_vm._v("キャンセル")]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-body" }, [
      _c("span", [_vm._v("このアイテムを削除してもよろしいですか？")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-632e8898", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-632e8898","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalDeleteAlert.vue
// module id = null
// module chunks = 